import React from 'react';
import classNames from 'classnames';
import WarningExclamationIcon from 'icons/WarningExclamation.icon';

import './NotVerifiedBadge.styles.scss';

type NotVerifiedBadgeProps = {
  className?: string;
  text?: string;
};

const NotVerifiedBadge: React.FC<NotVerifiedBadgeProps> = (props) => {
  const { className, text } = props;

  const classes = classNames(
    'not-verified-badge',
    { 'not-verified-badge--small': !text },
    className,
  );

  return (
    <div className={classes}>
      <WarningExclamationIcon />
      {text && <span>{text}</span>}
    </div>
  );
};

export default NotVerifiedBadge;
